import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface ResourceDeletedSliceState {
  parentFolderId: number | null;
  folderId: number;
  fileId: number; 
}

const initialState: ResourceDeletedSliceState = {
  parentFolderId : GLOBALSETTINGS.DEFAULT_STATE,
  folderId: GLOBALSETTINGS.DEFAULT_STATE,
  fileId: GLOBALSETTINGS.DEFAULT_STATE
};

const resourceDeletedSlice = createSlice({
  name: 'ResourceDeleted',
  initialState,
  reducers: {
    setResourceDeleted(state, action: PayloadAction<{ folderId: number, 
      parentFolderId: number | null , fileId: number}>) {
      state.folderId = action.payload.folderId;
      state.parentFolderId = action.payload.parentFolderId;
      state.fileId = action.payload.fileId;
    },
    clearResourceDeleted(state) {
      state.folderId = GLOBALSETTINGS.DEFAULT_STATE;
      state.parentFolderId = GLOBALSETTINGS.DEFAULT_STATE;
      state.fileId = GLOBALSETTINGS.DEFAULT_STATE;
    },
  },
});

export const { setResourceDeleted, clearResourceDeleted } = resourceDeletedSlice.actions;

export default resourceDeletedSlice.reducer;
